<template>
  <div class="blockLoading">
    <div class="loadingLogo">
      <img src="../../assets/img/loading.gif" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "blockLoading",
};
</script>
